import React from "react";
import T from "prop-types";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import api from "APP_ROOT/api";
import {
  translateProps,
  toggleSwitch,
  renderIf
} from "MODULES/shared/decorators";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { Icon, ConfirmAction } from "MODULES/shared/components";
import {
  NOT_EXCHANGED,
  SECOND_EXCHANGE,
  THIRD_EXCHANGE,
  EXCHANGE_CONFIG
} from "MODULES/SalesOrders/constants";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import { ADMIN, ACCOUNTING } from "MODULES/users/constants";
import withPurchaseOrder from "MODULES/PurchaseOrders/decorators/withPurchaseOrder";
import { isLastExchange } from "MODULES/PurchaseOrders/components/Detail/LineItemsTable/Outright/Outright";

export function Exchange({
  exchange,
  exchanging,
  open,
  close,
  confirmConfig: { text, actionText }
}) {
  return (
    <DropDownItem onClick={open}>
      <Icon name="refresh" fixed />
      <span className="with-padding">{text}</span>
      <ConfirmAction onConfirm={exchange} close={close} open={exchanging}>
        <strong>Heads up! </strong>
        <span className="with-padding">{actionText}</span>
      </ConfirmAction>
    </DropDownItem>
  );
}

Exchange.propTypes = {
  exchange: T.func.isRequired,
  exchanging: T.bool.isRequired,
  confirmConfig: T.shape({}).isRequired,
  open: T.func.isRequired,
  close: T.func.isRequired,
  ...WithCurrentUser
};

const withExchange = translateProps(
  ({
    lineItem: { exchange_type: exchangeType, id: itemId },
    close,
    pushHistory
  }) => ({
    exchange: () =>
      api.purchaseOrders.lineItems.exchange(itemId).then(({ data: { id } }) => {
        pushHistory({ pathname: `/purchase-orders/${id}` });
        close();
      }),
    confirmConfig:
      exchangeType === null
        ? EXCHANGE_CONFIG[NOT_EXCHANGED]
        : EXCHANGE_CONFIG[SECOND_EXCHANGE]
  })
);

const meetsExchangeCriteria = renderIf(
  ({ lineItem, currentUser: { role } }) =>
    [ADMIN, ACCOUNTING].includes(role) &&
    !lineItem.cancelled &&
    isLastExchange(lineItem) &&
    lineItem.exchange_type !== THIRD_EXCHANGE
);

export const exchange = withPurchaseOrder(
  toggleSwitch("exchanging")(
    withCurrentUser(withExchange(meetsExchangeCriteria(Exchange)))
  )
);

export default connect(undefined, { pushHistory: push })(exchange);



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/LineItemsTable/Exchange/Exchange.jsx